import React, { Fragment, forwardRef, useState, useEffect } from "react";
import UploadButtonInput from "ReusableComponents/UploadButtonInput";
import cloneDeep from "lodash.clonedeep";
import { Input, Row, Col, Typography } from 'antd';
import Checkbox from "antd/es/checkbox/index";
import Title from 'antd/es/typography/Title';
import Text from 'antd/es/typography/Text';
import TranslatedText from "translations/TranslatedText";

export default function URLConfig(props: any) {
  const {
    mediaFiles,
    onChange,
  } = props;
  const [medias, setMedias] = useState(mediaFiles)

  const parseUrl = (url: string, index: number) => {
    const clonedMedia = cloneDeep(medias);
    clonedMedia[index].title = url.substring(url.lastIndexOf('/')+1).split('.')[0];
    clonedMedia[index].src = url;
    setMedias(clonedMedia);
  }
  const saveTitle = (title: string, index: number) => {
    const clonedMedia = cloneDeep(medias);
    clonedMedia[index].title = title;
    setMedias(clonedMedia);
  }
  const setAnswerProp = (index: number) => {
    const clonedMedia = cloneDeep(medias);
    clonedMedia[index].is_answer = !clonedMedia[index].is_answer;
    setMedias(clonedMedia);
  }
  const setShowTitle = (index: number) => {
    const clonedMedia = cloneDeep(medias);
    clonedMedia[index].show_title = !clonedMedia[index].show_title;
    setMedias(clonedMedia);
  }

  useEffect(() => {
    onChange(medias);
  }, [medias]);

  return (
    <Fragment>
      <Row type="flex" justify="space-between" align="middle">
        <Col span={6}>
          <Typography style={{ textAlign: 'center' }}>
            <TranslatedText id="settings.form.multichoice.responses.media" />
          </Typography>
        </Col>
        <Col span={7}>
          <Typography style={{ textAlign: 'center' }}>
            <TranslatedText id="settings.form.multichoice.responses.Answer" />
          </Typography>
        </Col>
        <Col span={5}>
          <Typography style={{ textAlign: 'center' }}>
            <TranslatedText id="settings.form.multichoice.responses.correct" />
          </Typography>
        </Col>
        <Col>
          <Typography style={{ textAlign: 'center' }}>
            <TranslatedText id="settings.form.multichoice.responses.showtitle" />
          </Typography>
        </Col>
      </Row>
      <ol>
      {
        medias.map((media: any, index: number)=>{
          return (
            <li key={index}>
              <Row type="flex" justify="space-between" align="middle" gutter={[8,8]}>
                <Col span={6}>
                  <Input
                    onChange={(event: any)=>parseUrl(event.target.value, index)}
                    value={media.src}
                  />
                </Col>
                <Col span={7}>
                  <Input
                    onChange={(event: any)=>saveTitle(event.target.value, index)}
                    value={media.title}
                  />
                </Col>
                <Col span={5} push={1}>
                  <Checkbox
                    onChange={event=>setAnswerProp(index)}
                    checked={media.is_answer}
                  />
                </Col>
                <Col>
                  <Checkbox
                    onChange={event=>setShowTitle(index)}
                    checked={media.show_title}
                  />
                </Col>
              </Row>
            </li>
          )
        })
      }
      </ol>
    </Fragment>
  );
};